export const GatewayNonCriticalIssueTroubleshooting = () =>
    <div className="font-normal text-sm p-3 bg-blue-50 rounded">
        <h4 className="font-semibold">
            For efficient resolution of any system issues, please follow these steps:
        </h4>
        <ul className="mt-4 list-decimal pl-5">
            <li>
                <span className="font-semibold">Log into</span> the <span className="font-semibold">Enphase
                    Enlighten Portal</span> at <a
                    href="https://enlighten.enphaseenergy.com/"
                    target="_blank"
                    rel="noreferrer"
                >https://enlighten.enphaseenergy.com/</a>, <span className="font-semibold">select</span> the
                warranty holder's site from the <span className="font-semibold">systems list</span>.
            </li>

            <li>
                <span className="font-semibold">Navigate</span> to
                the<span className="font-semibold"> Devices</span> or <span className="font-semibold">Communications
                    tab</span> to identify Gateway warnings.
            </li>
            <li>
                Inspect any <span className="font-semibold">alerts or notifications</span> related to the Gateway.
            </li>
            <li>
                <span className="font-semibold">Check</span> the Gateway's physical connections and power
                source for any disruptions.
            </li>
            <li>
                <span className="font-semibold">If the issue persists, reset</span> the Gateway by turning it off
                and on again.
            </li>
            <li>
                <span className="font-semibold">Review</span> the <span className="font-semibold">Installation and
                    Operation Manual</span> for troubleshooting non-critical issues.
            </li>
            <li>
                For persistent problems, <span className="font-semibold">contact Enphase Customer Support</span> to
                resolve the issue without affecting your system’s operation.
            </li>
        </ul>
    </div>
